
import { defineComponent } from 'vue'
export default defineComponent({
    name: 'info-about-company-name-and-department'
})
